import React, { Component } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import classNames from "classnames";
import Heading from "../../elements/heading";

export default class Consent extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      headingType: {},
      headingBody: {},
      body: {}
    };
  }

  consentContent(model) {
    const {
      gridType,
      paddingAboveTop,
      paddingAboveBottom,
      backgroundColor
    } = model.fields;
    const { headingType, headingBody, body } = this.state;
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom
        ? paddingAboveBottom.fields.phrase.value
        : "default";
    const consentContentClasses = classNames(
      "consent-content",
      "grid",
      "padding-top-" + top,
      "padding-bottom-" + bottom,
      {
        grid: (gridType && gridType.fields.phrase.value) === "normal"
      },
      {
        "grid-story": (gridType && gridType.fields.phrase.value) === "story"
      }
    );

    let backgroundStyle = {};
    if (backgroundColor) {
      backgroundStyle = {
        backgroundColor: backgroundColor.fields.phrase.value
      };
    }

    return (
      <div
        className={consentContentClasses}
        style={backgroundStyle}
        datasourceid={this.props.rendering.dataSource}
      >
        <div className={"content"}>
          {headingBody && (
            <Heading
              {...{
                html: headingBody,
                type: headingType
              }}
              className={"title"}
            />
          )}

          {body && <RichText tag="div" className={"body-text"} field={body} />}
        </div>
      </div>
    );
  }

  documentChange(state) {
    let { headingBody, body } = this.state;
    if (headingBody) {
      let node = document.createElement("div");
      node.innerHTML = headingBody.value;
      if (node.firstChild && node.firstChild.className === "") {
        node.firstChild.className = "type-h1";
        headingBody.value = node.innerHTML;
        this.setState({
          headingBody: headingBody
        });
      }
    }
    // set default heading style if non is set from the RTF in sitecore
    if (body) {
      let node2 = document.createElement("div");
      node2.innerHTML = body.value;

      let resultNode = document.createElement("div");

      let array = Array.from(node2.children);
      array.forEach(element => {
        if (element.nodeName === "H1" && element.firstChild.className === "") {
          element.firstChild.className = "type-h1";
        } else if (
          element.nodeName === "H2" &&
          element.firstChild.className === ""
        ) {
          element.firstChild.className = "type-h2";
        } else if (
          element.nodeName === "H3" &&
          element.firstChild.className === ""
        ) {
          element.firstChild.className = "type-h3";
        } else if (
          element.nodeName === "H4" &&
          element.firstChild.className === ""
        ) {
          element.firstChild.className = "type-h4";
        }
        resultNode.appendChild(element);
      });
      body.value = resultNode.innerHTML;
      this.setState({
        body: body
      });
    }
  }
  componentDidMount(props) {
    let model = this.props;
    this.documentChange(model);
    //废弃接口
    /*api.detail
      .post(null, {
        // "Content-Type": "application/json",
        // "Accept": "application/json",
        // "channel": "CONSENTCHANNEL02",
        // "organization": 13,
        language: "EN",
        consentNo: "test-cc-1399"
      })
      .then(res => {
        this.setState({
          headingType: { fields: { phrase: { value: "h1" } } },
          headingBody: {
            value: `<sapn class="type-h1">${res.obj.title}</span>`
          },
          body: {
            value: `<div class="body-text"><br/><p>${res.obj.context} </p>`
          }
        });
        //             this.props.fields.headingType.fields.phrase.value="h1"
        //             this.props.fields.headingBody.value=`<sapn class="type-h1">789111</span>`
        //             this.props.fields.body.value=`<div class="body-text"><br/>

        //this.forceUpdate()
      })
      .catch();*/
  }
  shouldComponentUpdate(nextState) {
    if (this.state !== nextState) return true;
  }
  render() {
    if (!this.props.fields) return null;
    let model = this.props,
      { gridType } = model.fields;

    if ((gridType && gridType.fields.phrase.value) === "story") {
      return <div className={"grid"}>{this.consentContent(model)}</div>;
    } else {
      return this.consentContent(model);
    }
  }
}
